import React, {useContext} from "react";

import { ContentElementRenderer } from "../../../components/ContentElementRenderer";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./TwoColumn.module.less";
import GeneralPageContext from "../../../templates/GeneralPageContext";

export function TwoColumn({ leftColumn, rightColumn, hasLightBackground, withGallery}) {
    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    return (
        <div
            className={gcs(
                styles.twoColumn,
                [
                    showAnchorNavigation,
                    styles.anchored
                ],
                (leftColumn.type = "DatoCmsNestedImage" ? styles.reverse : ""),
                "twoColumn"
            )}
        >
            <div className={styles.left}>
                <ContentElementRenderer
                    items={leftColumn}
                    hasLightBackground={hasLightBackground}
                    additionalContext={{ column: 2 }}
                    withGallery={withGallery}
                />
            </div>
            <div className={styles.right}>
                <ContentElementRenderer
                    items={rightColumn}
                    hasLightBackground={hasLightBackground}
                    additionalContext={{ column: 2 }}
                    withGallery={withGallery}
                />
            </div>
        </div>
    );
}
